import { useMemo } from 'react'

import { applyServerErrors } from '@/components/Chat/formServerErrors'
import { type SaveResult, type SyncedForm, useSyncedForm } from '@/components/Chat/useSyncedForm'
import { normalizeShares } from '@/lib/freightAllocation'
import { type CommodityItem, updateFreightTypes } from '@/models/user'

export interface FreightValues {
  commodities: CommodityItem[]
}

export interface FreightForm extends SyncedForm<FreightValues> {
  save: (orgId: string, options: { onlyChanged: boolean }) => Promise<SaveResult>
}

const ERROR_FIELDS = { commodities: 'commodities' } as const

export function useFreightForm(commodities: CommodityItem[] | undefined): FreightForm {
  const values = useMemo(() => ({ commodities: normalizeShares(commodities ?? []) }), [commodities])
  const synced = useSyncedForm(values)

  async function save(orgId: string, { onlyChanged }: { onlyChanged: boolean }): Promise<SaveResult> {
    const { form, changedFields, markSaved } = synced
    form.clearErrors()
    if (onlyChanged && changedFields.length === 0) return { ok: true }
    try {
      await updateFreightTypes(orgId, form.getValues('commodities'))
      markSaved()
      return { ok: true }
    } catch (error) {
      applyServerErrors(form, error, ERROR_FIELDS)
      return { ok: false, error }
    }
  }

  return { ...synced, save }
}
